import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    warningHelp:
      'If it is an error on your document, you can correct it and import your file again. If not, you can ignore this information and continue.',
    warningMessage: `The IBAN entered for this person is registered in the list of your beneficiaries under the name "**{0}**".`,
    warningTitle: 'There may be an error',
  },
  fr: {
    warningHelp: `S’il s'agit d’une erreur sur votre document, vous pouvez la corriger et importer à nouveau votre fichier. Si ce n’est pas le cas, vous pouvez ignorer cette information et continuer.`,
    warningMessage: `L’IBAN renseigné pour cette personne est enregistré dans la liste de vos bénéficiaires sous le nom de “**{0}**“.`,
    warningTitle: "Il s'agit peut-être d'une erreur",
  },
} as const);

export default locales;
